<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div class="international-langMessage">
      <!-- <svg-icon class-name="international-icon" icon-class="language" /> -->
      {{ langMessage }}
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in i18nList" :key="item.id" :disabled="language===item.languageCode" :command="item.languageCode">
        {{ item.description }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
// import { getAllZlLanguage } from '@/api/enumeration/getAllZlLanguage'
const getAllZlLanguage = [{ 'id': 1, 'languageCode': 'zh_CN', 'description': '简体中文' }, { 'id': 2, 'languageCode': 'zh_TW', 'description': '繁體中文' }, { 'id': 3, 'languageCode': 'en_US', 'description': 'English' }]
export default {
  data() {
    return {
      i18nList: []
    }
  },
  computed: {
    languageMap() {
      const map = {}
      this.i18nList.forEach(item => {
        map[item.languageCode] = item.description
      })
      return map
    },
    language() {
      return this.$store.getters.language
    },
    langMessage() {
      return this.languageMap[this.language] || ''
    }
  },
  async created() {
    const data = getAllZlLanguage
    this.i18nList = data.map(i => ({ ...i, languageCode: i.languageCode.replace('_', '-') }))
  },
  methods: {
    async handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      this.$emit('change')
      this.$message({
        message: this.$t('message.success'),
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.international-langMessage {
  height: 20px;
  line-height: 20px;
  color: #606266;
  font-size: 12px;
  &:hover {
    color: #008ee3;
  }
}
</style>
